import React from 'react'
import "./Loading.css"

const loading = () =>{
    return(
        <div className="box1">
            <h1>Loading</h1>
        </div>
    )
}
export default loading